import { useNavigate, useLocation, Navigate } from "react-router-dom";
import React, { useState, useEffect, useRef } from 'react';

import { collection, query, where, getDocs, orderBy } from "firebase/firestore";
import { db } from "../firebase";
import { Helmet } from "react-helmet";
import { Toast } from '../components_root/ToastContext';
import { Create_page } from "./create_page";
import { Randomcode } from "../components_root/rendom_code";
import Cookies from "js-cookie";
import { RiPagesLine } from "react-icons/ri";
import { HiOutlineDuplicate } from "react-icons/hi";
import { MdAdd, MdDeleteForever, MdEdit, MdSave, MdSaveAlt } from "react-icons/md";
import { Delete_page } from "./delete_page";
import { Create_plugins } from "./create_plugins";

import { Plugins_install_page } from "./plugins_install_page";
export const seo = {
    title: "Create Page | Website Builder",
    description:
        "Create and publish your own web pages easily using our website builder. Add page name, description, and SEO keywords in seconds.",
    keywords:
        "create page, website builder page, add new page, cms page creation, dynamic page builder, create website page online",
    url: "/create-page",
    image: "/assets/logo.png"
};
export default function Editer() {
    const navigate = useNavigate();
    const location = useLocation();
    const { Toastshow } = Toast();
    const [page_name, setpage_name] = useState("");
    const [page_title, setpage_title] = useState("");

    const [page_description, setpage_description] = useState("");
    const [page_keywords, setpage_keywords] = useState("");
    const [page_status, setpage_status] = useState(false);
    const [menu_status, setmenu_status] = useState(false);
    const [slug, setslug] = useState("");
    const [editpageTab, seteditpageTab] = useState("pageuid");
    const [page_listdata, setPage_listdata] = useState([]);
    const [page_editdata, setPage_editdata] = useState([]);
    const [pluginsdata, setpluginsdata] = useState([]);
    const [pageuid, setpageuid] = useState(Randomcode(16));
    const [confirmDelete, setConfirmDelete] = useState(false);

    const [companyuid, setcompanyuid] = useState(Cookies.get("website_company_uid"));
    useEffect(() => {
        const compuid = Cookies.get("website_company_uid");
        setcompanyuid(compuid);
    }, []);
    useEffect(() => {
        const guids = Cookies.get("guid");

        if (!guids || guids === "undefined" || guids === null) {
            navigate("/");
        }
    }, [navigate, companyuid]);
    //
    const fetchData = async () => {
        try {
            const companyuid = Cookies.get("website_company_uid");

            const servicetablename = "companies";
            const tablename = "pages";

            const companySnap = await getDocs(
                query(collection(db, servicetablename, companyuid, tablename),
                    orderBy("indexnumber", "asc"),
                )
            );

            if (!companySnap.empty) {
                const data = companySnap.docs.map(doc => ({
                    ...doc.data(),
                    uid: doc.id
                }));

                setPage_listdata(data); // ✅ now it's an array
            }
        } catch (err) {
            console.error("Error:", err);
        }
    };
    useEffect(() => {
        fetchData();
    }, [pageuid]);
    //
    const fetch_editpagedata = async (uid) => {
        try {
            const companyuid = Cookies.get("website_company_uid");

            const companySnap = await getDocs(
                query(
                    collection(db, "companies", companyuid, "pages"),
                    where("pageuid", "==", uid),
                )
            );

            if (!companySnap.empty) {
                const data = companySnap.docs.map(doc => ({
                    ...doc.data(),
                    uid: doc.id
                }));
                setpage_status(data[0].status);
                setmenu_status(data[0].menu_status);
                setslug(data[0].slug);
                setpage_name(data[0].page_name);
                setpage_title(data[0].page_title);
                setpage_description(data[0].page_description);
                setpage_keywords(data[0].page_keywords);
                setPage_editdata(data);
            }

        } catch (err) {
            console.error("Error:", err);
        }
    };
    const Create_page_Save = async () => {

        try {

            if (!page_name?.trim()) {
                Toastshow("Please enter page name");
                return;
            }
            if (!page_title?.trim()) {
                Toastshow("Please enter page title");
                return;
            }
            if (!page_description?.trim()) {
                Toastshow("Please enter page description");
                return;
            }
            if (!page_keywords?.trim()) {
                Toastshow("Please enter pag keywords");
                return;
            }


            const res = await Create_page({
                companyuid,
                pageuid,
                menu_status,
                slug,
                status: page_status,
                page_name,
                page_title,
                page_description,
                page_keywords
            });

            if (res.success) {
                navigate("/editer/?p=edit_page&pageuid=" + pageuid);
                fetchData();
                Toastshow("Page saved successfully!");
            } else {
                Toastshow(res.error || "Failed to save page");
            }

        } catch (err) {
            console.error("Error saving page:", err);
            Toastshow("Something went wrong. Please try again.");
        }

    };

    useEffect(() => {
        const params = new URLSearchParams(location.search);

        const tab = params.get("p") || "home";
        const uid = params.get("pageuid") || "";

        seteditpageTab(tab);
        setpageuid(uid);

        if (uid && tab === "edit_page") {
            fetch_editpagedata(uid);
        } else {
            setpage_status(false);
            setslug("");
            setpage_name("");
            setpage_description("");
            setpage_keywords("");
        }

    }, [location.search]);

    const delete_page_action = async () => {
        const res = await Delete_page({ pageuid, companyuid });
        if (res.success) {
            navigate("/editer/?p=new_page&pageuid=" + Randomcode(16));
            fetchData();
            Toastshow("Page delete successfully!");
            setConfirmDelete(false);
        } else {
            Toastshow(res.error || "Failed to delete page");
        }
    }

    const Create_plugins_Save = async () => {

        try {

            if (!page_name?.trim()) {
                Toastshow("Please enter page name");
                return;
            }
            if (!page_description?.trim()) {
                Toastshow("Please enter page description");
                return;
            }


            const res = await Create_plugins({
                pluguid: Randomcode(10),
                Plugin_icon: "",
                menu_status,
                slug,
                status: true,
                plugins_name: page_name,
                plugins_description: page_description
            });

            if (res.success) {
                setpage_status(false);
                setslug("");
                setpage_name("");
                setpage_description("");
                setpage_keywords("");
                Toastshow("Saved successfully!");
                fetch_Plugin();
            } else {
                Toastshow(res.error || "Failed to save");
            }

        } catch (err) {
            console.error("Error saving :", err);
            Toastshow("Something went wrong. Please try again.");
        }

    };
    const fetch_Plugin = async () => {
        try {
            // ================= ALL PLUGINS =================
            const allPluginsSnap = await getDocs(
                query(
                    collection(db, "plugins"),
                    where("status", "==", true)
                )
            );

            let allPlugins = [];

            if (!allPluginsSnap.empty) {

                // ✅ async map with Promise.all
                allPlugins = await Promise.all(
                    allPluginsSnap.docs.map(async (docSnap) => {

                        const pluginData = docSnap.data();
                        const pluginId = docSnap.id;

                        // ================= CHECK INSTALLED =================
                        const installedSnap = await getDocs(
                            query(
                                collection(
                                    db,
                                    "companies",
                                    companyuid,
                                    "pages",
                                    pageuid,
                                    "plugins"
                                ),
                                where("pluguid", "==", pluginId) // ✅ correct
                            )
                        );

                        return {
                            ...pluginData,
                            uid: pluginId,
                            installed: !installedSnap.empty, // ✅ true/false
                            install_count: installedSnap.size // ✅ count
                        };
                    })
                );
            }

            setpluginsdata(allPlugins);

        } catch (err) {
            console.error("Error:", err);
        }
    };

    useEffect(() => {
        fetch_Plugin();
    }, [pageuid, companyuid]);


    const Plugins_install_page_Save = async (pluguid, Plugin_icon, plugins_name, plugins_description) => {

        try {

            if (!plugins_name?.trim()) {
                Toastshow("Please enter  name");
                return;
            }
            if (!plugins_description?.trim()) {
                Toastshow("Please enter  description");
                return;
            }


            const res = await Plugins_install_page({
                pluguid,
                pageuid,
                companyuid,
                Plugin_icon,
                status: true,
                plugins_name,
                plugins_description
            });

            if (res.success) {
                Toastshow("Install successfully!");
                fetch_Plugin();
            } else {
                Toastshow(res.error || "Failed to save");
            }

        } catch (err) {
            console.error("Error saving :", err);
            Toastshow("Something went wrong. Please try again.");
        }

    };
    const page_not_delte = ["home", "feedback", "contact", "contact-us", "support", "explore"];
    return (
        <div>

            <Helmet>
                <title>{seo.title}</title>
                <meta name="description" content={seo.description} />
                <meta name="keywords" content={seo.keywords} />
                <meta property="og:title" content={seo.title} />
                <meta property="og:description" content={seo.description} />
                <meta property="og:image" content={seo.image} />
                <meta property="og:url" content={seo.url} />
            </Helmet>

            <div className="container_roots b-top">
                <div >
                    <div className='post-container'>

                        <div className="post_post">
                            <div className="ui-grid">
                                <div className="ui-items items-back-fill rounded p-1 cursor">
                                    <table>
                                        <tr>
                                            <td width={30}><MdAdd className='icon' /></td>
                                            <td> <div onClick={() => navigate("/editer/?p=new_page&pageuid=" + Randomcode(16))} className="text-h2 bold fcap">new page</div></td>
                                            <td width={30}> <div className="text-h2 ">{page_listdata.length | "0"}</div></td>
                                        </tr>
                                    </table>

                                </div>
                                {page_listdata.length > 0 && (
                                    page_listdata.map((row, index) => (
                                        <div className="ui-items items-back-fill rounded p-1 cursor" key={index} onClick={() => navigate("/editer/?p=edit_page&pageuid=" + row.pageuid)}>
                                            <table>
                                                <tr>
                                                    <td width={30}><RiPagesLine className='icon' /></td>
                                                    <td> <div className="text-h2 bold fcap">{row.page_name}</div></td>

                                                    <td width={50}>
                                                        <div className={`text-h3 ${row.status ? "green" : "red"}`}>
                                                            {row.status ? "Published" : "Unpublished"}
                                                        </div>
                                                    </td>
                                                </tr>
                                            </table>

                                        </div>
                                    ))
                                )}
                            </div>
                        </div>
                        <div className='post_div'>



                            <div className="text-h1 bold m-top fcap">{editpageTab.replaceAll("_", " ")}</div>
                            <table>
                                <tr>

                                    <td>
                                        <div className="text-off text-h3">
                                            <table>
                                                <tr>
                                                    <td width={60}>Page uid</td>
                                                    <td><a className="items-back-fill p-11 rounded">{pageuid}</a> <a className="items-back-fill p-11 rounded">  {page_editdata?.[0]?.date_time?.seconds
                                                        ? new Date(page_editdata[0].date_time.seconds * 1000).toLocaleString()
                                                        : new Date().toLocaleString()}</a></td>
                                                </tr>
                                                <tr className="m-top">
                                                    <td width={60}>Page URL</td>
                                                    <td><a  >{slug.length > 2 ? <a className="blue">{window.location.origin}/{slug}</a> : "..."}</a></td>
                                                </tr>
                                            </table>


                                        </div>
                                    </td>

                                    <td width={100}>
                                        <div className="button-ui3 p-11 cursor" onClick={() => setmenu_status(!menu_status)}>
                                            {menu_status === true ? "Menu Show" : "Menu Hide"}
                                        </div>
                                    </td>
                                    <td width={80}>
                                        <div className={`button-ui3 p-11 cursor ${page_status ? "green" : "red"}`} onClick={() => setpage_status(!page_status)}>
                                            {page_status ? "Published" : "Unpublished"}
                                        </div>
                                    </td>
                                </tr>
                            </table>

                            <div className="m-top">
                                <input className="p-1 fcap bold text-h1" value={page_name}
                                    onChange={(e) => {
                                        const value = e.target.value;
                                        setpage_name(value);
                                        const slug = value
                                            .toLowerCase()
                                            .replace(/[^a-z0-9\s-]/g, "")
                                            .trim()
                                            .replace(/\s+/g, "-");

                                        setslug(slug);
                                    }} maxLength={30} placeholder="Enter new page name" />
                            </div>
                            <div className="m-top">
                                <input className="p-1 fcap bold text-h1" value={page_title}
                                    onChange={(e) => {
                                        const value = e.target.value;
                                        setpage_title(value);

                                    }} maxLength={100} placeholder="Enter new page title" />
                            </div>


                            <div className="m-top">
                                <textarea className="p-1 " value={page_description} onChange={(e) => setpage_description(e.target.value)} maxLength={200} placeholder="Enter description" />
                            </div>
                            <div className="m-top">
                                <textarea className="p-1" value={page_keywords} onChange={(e) => setpage_keywords(e.target.value)} maxLength={300} placeholder="Enter keywords" />
                            </div>
                            <br />
                            <table>
                                <tr>


                                    {editpageTab === "edit_page" && (
                                        <td width={180} >
                                            <div>
                                                <div className="text-h3 text-off text-l" >Update:
                                                    {page_editdata?.[0]?.update_date_time
                                                        ? new Date(page_editdata[0].update_date_time.seconds * 1000).toLocaleString()
                                                        : "-"}</div>

                                            </div>
                                        </td>
                                    )}
                                    <td >
                                        <div onClick={() => Create_plugins_Save()} className="button-ui0 p-11 text-h2 cursor green m-top"><MdSave className="icon" />Create_plugins</div>
                                    </td>

                                    <td >
                                        <div onClick={() => Create_page_Save()} className="button-ui p-11 text-h2 cursor m-top"><MdSave className="icon" />{editpageTab === "edit_page" ? "Changes" : "Continue &"} Save </div>
                                    </td>

                                    {editpageTab === "edit_page" && !page_not_delte.includes(slug) && (

                                        <td width={230}>
                                            <table>
                                                <tr>
                                                    <td>
                                                        <input
                                                            type="checkbox"
                                                            checked={confirmDelete}
                                                            onChange={(e) => setConfirmDelete(e.target.checked)}
                                                        />
                                                        I agree to delete page
                                                    </td>
                                                    {confirmDelete === true && (
                                                        <td width={70}>
                                                            <div
                                                                onClick={async () => {
                                                                    if (!confirmDelete) {
                                                                        Toastshow("Please confirm delete");
                                                                        return;
                                                                    }
                                                                    delete_page_action();

                                                                }}
                                                                className="button-ui red-back p-11 text-h2 cursor m-top"
                                                            >
                                                                Delete
                                                            </div>
                                                        </td>
                                                    )}

                                                </tr>
                                            </table>
                                        </td>
                                    )}

                                </tr>
                            </table>
                            <br />
                            <div>
                                <table>
                                    <tr>
                                        <td>        <div className="text-h1 bold fcap">Install UI Plugins & Add Features</div></td>
                                        {editpageTab === "edit_page" && (
                                            <>
                                                {/* <td width={130}> <div className="button-ui3 cursor  "><HiOutlineDuplicate className="icon" />Page Duplicate</div></td> */}
                                                <td width={70}> <div className="button-ui3 cursor  " onClick={() => {
                                                    if (slug === "home") {
                                                        navigate("/editer-home/?pageuid=" + pageuid)
                                                    } else {
                                                        navigate("/editer-page/?pageuid=" + pageuid)
                                                    }

                                                }}><MdEdit className="icon" /> Editor</div></td>
                                            </>
                                        )}

                                    </tr>
                                </table>

                                <div className="ui-grid">
                                    {pluginsdata.length > 0 &&
                                        pluginsdata.map((row) => (
                                            <div
                                                className="ui-items items-back b-1 rounded p-1 cursor"
                                                key={row.uid} // ✅ better key
                                            >
                                                <div className="text-h1 center bold fcap">
                                                    {row.plugins_name}
                                                </div>

                                                <div className="text-h3 fcap">
                                                    {row.plugins_description} id:- {row.pluguid}
                                                </div>



                                                {/* ✅ Button Logic */}
                                                <div
                                                    className={` text-h2 bold fill p-22 ${row.installed ? "button-ui" : "button-ui2"
                                                        }`}

                                                    onClick={() => {
                                                        if (editpageTab !== "edit_page") {
                                                            Toastshow("First create or select page");
                                                            return;
                                                        }

                                                        Plugins_install_page_Save(
                                                            row.uid, // ✅ FIX (not row.pluguid)
                                                            row.Plugin_icon,
                                                            row.plugins_name,
                                                            row.plugins_description
                                                        );
                                                    }}
                                                >
                                                    {row.installed ? (
                                                        <>Installed ({row.install_count || 0})</>
                                                    ) : (
                                                        "Install"
                                                    )}
                                                </div>
                                            </div>
                                        ))}
                                </div>
                            </div>


                        </div>
                        <div className="post_updates">

                            <div className="text-h1 bold">Create New Page</div>

                            <p>
                                Use this section to create a new page for your website.
                            </p>

                            <h3>Steps to Create a Page</h3>

                            <ol>

                                <li>
                                    <strong>Enter Page Name</strong>
                                    <p>This will be the title of your page (e.g., About Us, Contact, Services).</p>
                                </li>

                                <li>
                                    <strong>Add Page Description</strong>
                                    <p>
                                        Write a short description of your page content. This helps users and search engines understand your page.
                                    </p>
                                </li>

                                <li>
                                    <strong>Enter Keywords</strong>
                                    <p>
                                        Add relevant keywords separated by commas. These improve your page visibility in search engines.
                                    </p>
                                </li>

                                <li>
                                    <strong>Generate URL (Slug)</strong>
                                    <p>
                                        Your page link will be automatically created based on the page name.
                                    </p>
                                </li>

                                <li>
                                    <strong>Save Page</strong>
                                    <p>
                                        Click the save button to create your page. You can edit it anytime later.
                                    </p>
                                </li>

                            </ol>

                            <p className="mt-2">
                                Once created, your page will be available on your website and ready for content updates.
                            </p>

                        </div>
                    </div>
                </div>
            </div>
        </div >
    );
}
